import { useProviderHelp } from './useHelp';
import { ZendeskWidgetContext } from './ZendeskWidgetContext';

const ZendeskHelpContainer = ({ children }: { children: React.ReactNode }) => {
  const helpValue = useProviderHelp();
  return (
    <ZendeskWidgetContext.Provider value={helpValue}>{children}</ZendeskWidgetContext.Provider>
  );
};

export default ZendeskHelpContainer;
